import { render, staticRenderFns } from "./TaskStatusChange.vue?vue&type=template&id=51a086d4&"
import script from "./TaskStatusChange.vue?vue&type=script&lang=js&"
export * from "./TaskStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports